import Vue from 'vue'
import VueRouter from 'vue-router'

// import Vuex from '../store/index'
Vue.use(VueRouter);

const routes = [
    {
        path: '/invite',
        name: 'invite',
        component: () => import('../views/Invite.vue')
    },
    {
        path: '/wxAuth',
        name: 'wxAuth',
        component: () => import('../views/WxAuth.vue')
    },
    {
        path: '/designShare',
        name: 'designShare',
        component: () => import('../views/DesignShare.vue')
    },
];
const router = new VueRouter({
    mode:'history',
    routes:routes
});
// const routerPush = routes.prototype.push;
// routes.prototype.push = function push(location) {
//     return routerPush.call(this, location).catch(error=> error)
// }
export default router;